import { render, staticRenderFns } from "./AreaofStudy.vue?vue&type=template&id=78dc9a83"
import script from "./AreaofStudy.vue?vue&type=script&lang=js"
export * from "./AreaofStudy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports